import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const SELECTOR_SECTION = '.block-content-split';
const SELECTOR_MEDIA = '.block-content-split__media-inner';
const INIT_ATTR = 'data-media-lag-init';
const TRAVEL_FROM = -15;
const TRAVEL_TO = 15;
const SCRUB_LAG_SECONDS = 0.4;
const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const initMediaLag = () => {
    document.querySelectorAll(SELECTOR_SECTION).forEach((section) => {
        if (section.hasAttribute(INIT_ATTR))
            return;
        section.setAttribute(INIT_ATTR, '');
        const media = section.querySelector(SELECTOR_MEDIA);
        if (!media || reducedMotion())
            return;
        gsap.fromTo(media, { yPercent: TRAVEL_FROM }, {
            yPercent: TRAVEL_TO,
            ease: 'none',
            scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: SCRUB_LAG_SECONDS,
            },
        });
    });
};
document.addEventListener('DOMContentLoaded', initMediaLag);
if (window.acf) {
    window.acf.addAction('render_block_preview', initMediaLag);
}
window.addEventListener('load', () => ScrollTrigger.refresh());
export default initMediaLag;
